import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, ParamMap, Router } from "@angular/router";
import { Location } from "@angular/common";
import { forkJoin } from "rxjs";
import { AppService } from "src/app/app.service";

@Component({
    selector: "app-video-gallery",
    templateUrl: "./video-gallery.component.html",
    styleUrls: ["./video-gallery.component.scss"],
})
export class VideoGalleryComponent implements OnInit {
    items: string[] = ["photos", "videos"];
    selectedItem: string = "videos";
    imageLoaded = false;
    fetchinData = true;
    ImageAlbums: any;
    VideoAlbums: any;
    constructor(
        private route: ActivatedRoute,
        private location: Location,
        private appService: AppService,
        private router: Router
    ) { }

    ngOnInit() {
        this.FetchAlbums();
    }

    selectItem() {
        this.router.navigate(["/photo-gallery"]);
    }

    onImageLoad() {
        this.imageLoaded = true;
    }

    FetchAlbums() {
        forkJoin([this.appService.getVideoAlbums()]).subscribe(
            (response: any) => {
                console.log(response, "response Albums");

                this.VideoAlbums = response[0].data;
                this.fetchVideoThumbnails(this.VideoAlbums);

                this.fetchinData = false;
            }
        );
    }

    TransformUrl(value) {
        if (value.includes("https://")) {
            return value;
        } else {
            return `https://${value}`;
        }
    }

    fetchVideoThumbnails(albums: any[]) {
        if (!albums) return;
        albums.forEach(album => {
            if (!album.thumbnailLink) {
                const folderId = album.id || album.Id;
                if (folderId) {
                    this.appService.getVideoAlbumsById(folderId).subscribe((res: any) => {
                        const videos = res.data?.filter(item => item.IsAlbumFolder === false);
                        if (videos && videos.length > 0) {
                            const firstVideoUrl = videos[0].VideoId;
                            const regExp = /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/;
                            const match = firstVideoUrl?.match(regExp);
                            if (match && match[2].length === 11) {
                                album.thumbnailLink = `https://img.youtube.com/vi/${match[2]}/hqdefault.jpg`;
                            }
                        }
                    });
                }
            }
        });
    }
}
